import { styled } from "@mui/material/styles";

const CustomScrollbarStyle = styled("div")(
  ({ theme, scrollbarHeight = "100%" }) => ({
    height: scrollbarHeight,
    overflowY: "scroll",
    scrollbarWidth: "thin",
    scrollbarColor: "#B4B4B4 transparent",
    "&::-webkit-scrollbar": {
      width: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 6,
      backgroundColor: "#B4B4B4",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    [theme.breakpoints.down("md")]: {
      height: scrollbarHeight,
    },
    [theme.breakpoints.down("lg")]: {
      height: scrollbarHeight,
    },
  })
);
export { CustomScrollbarStyle };
